/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringFilterItemOutputWithIndent
 */
export interface StringFilterItemOutputWithIndent {
    /**
     * 
     * @type {number}
     * @memberof StringFilterItemOutputWithIndent
     */
    indent?: number;
    /**
     * 
     * @type {string}
     * @memberof StringFilterItemOutputWithIndent
     */
    displayText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringFilterItemOutputWithIndent
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringFilterItemOutputWithIndent
     */
    isEffective?: boolean;
}

export function StringFilterItemOutputWithIndentFromJSON(json: any): StringFilterItemOutputWithIndent {
    return StringFilterItemOutputWithIndentFromJSONTyped(json, false);
}

export function StringFilterItemOutputWithIndentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringFilterItemOutputWithIndent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'indent': !exists(json, 'indent') ? undefined : json['indent'],
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function StringFilterItemOutputWithIndentToJSON(value?: StringFilterItemOutputWithIndent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'indent': value.indent,
        'displayText': value.displayText,
        'value': value.value,
        'isEffective': value.isEffective,
    };
}


